<template>
  <div>
    <img class="logo" src="@/assets/images/header-logo.png" alt="">
    <div class="delivery section">
      <form model="subForm" >
        <div class="grid">
          <div class="grid">
            <p class=""><span class="point-red">필수입력</span></p>
            <div class="grid-item phone-num">
              <dl class="input-list">
                <dt>
                  <label for="gcct_no">
                    <span class="">쿠폰번호</span>
                    <strong>: {{ gcct_no }}</strong>
                  </label>
                </dt>
                <dt>
                  <label for="refund_amt">
                    <span>예상 환불금액</span>
                    <strong class="refund_amt">: {{ numberWithCommas(refund_amt) }}원</strong>
                    <span>(최종 환불금액은 환불 규정에 따라 변동될 수 있습니다.)</span>
                  </label>
                </dt>
                <dt>
                  <strong></strong>
                </dt>
                <dt>
                  <label for="csmr_name">
                    <span class="essential">계좌주명</span>
                  </label>
                </dt>
                <dd>
                  <input v-validate="{required: true}" id="csmr_name" v-model="subForm.csmr_name" type="text" name="csmr_name" class="input-default" >
                </dd>
                <dt>
                  <label for="csmr_recv_hp_tel">
                    <span class="essential">연락처</span>
                  </label>
                </dt>
                <dd>
                  <input v-validate="{required: true}" id="csmr_recv_hp_tel" v-model="subForm.csmr_recv_hp_tel" type="number" name="csmr_recv_hp_tel" class="input-default" data-vv-validate-on="change|focus|keyup" placeholder="숫자만 입력가능">
                </dd>
                <dt>
                  <label for="bankList">
                    <span class="essential">환불은행</span>
                  </label>
                </dt>
                <dd>
                  <select v-model="subForm.rfnd_fnlt_code" name="rfnd_fnlt_code" prop="rfnd_fnlt_code" >
                    <!-- <option value="" :selected="true">배송시 요청사항을 선택해 주세요</option> -->
                    <option v-for="item in bankList" :value="item.fnlt_code" :key="item.fnlt_code" placeholder="은행선택" >{{ item.fnlt_name }}</option>
                  </select>
                </dd>
                <dt>
                  <label for="rfnd_acnut_no">
                    <span class="essential">환불계좌</span>
                  </label>
                </dt>
                <dd>
                  <input v-validate="{required: true}" id="rfnd_acnut_no" v-model="subForm.rfnd_acnut_no" type="number" name="rfnd_acnut_no" class="input-default" data-vv-validate-on="change|focus|keyup" placeholder="숫자만 입력가능">
                </dd>
              </dl>
            </div>
          </div>
          <div class="grid-item privacy">
            <dl>
              <dt>
                <input v-validate="{required: true}" id="checkbox-sample" v-model="privacy" type="checkbox" class="checkbox-default" name="privacy" data-vv-validate-on="change">
                <label v-bind:class="{ 'on': !privacy}" for="checkbox-sample">
                  <span>개인정보 정보제공 및 수집안내에 동의합니다</span>
                </label>
              </dt>
              <dd v-show="!privacy">
                <dl>[개인정보 수집 안내]</dl>
                <dl>- 수집주체 : 스푼 주식회사</dl>
                <dl>- 수집하는 개인정보의 항목 계좌주명, 은행명, 계좌번호, 휴대폰번호</dl>
                <dl>- 개인정보의 수집 및 이용목적 : 환불 절차 진행을 위한 본인확인, 환불처리 및 결과안내</dl>
                <dl>- 개인정보의 보유 및 이용기간 : 전자상거래 등에서의 소비자보호에 관한법률 (거래 기록의 보존 등)에 의해 5년간 보관 후 삭제 됩니다.</dl>
              </dd>
              <dt>
                <input v-validate="{required: true}" id="checkbox-sample2" v-model="privacy2" type="checkbox" class="checkbox-default" name="privacy2" data-vv-validate-on="change">
                <label v-bind:class="{ 'on': !privacy2}" for="checkbox-sample2">
                  <span>환불규정 안내 및 환불일정에 동의합니다</span>
                </label>
              </dt>
              <dd v-show="!privacy2">
                <dl>[환불규정 안내]</dl>
                <dl>- 교환권은 미사용한 유효기간 만료 쿠폰에 대해서만 환불이 가능합니다.</dl>
                <dl>- 금액권은 최초 유효기간 경과 전에는 권면가액의 100분의60 (1만원권 이하 100분의 80)이상 사용 시 환불 가능합니다, </dl>
                <dl>- 구매 시 할인률은 제외됩니다. (잔액에서 할인율이 공제되고 입금 될 예정)</dl>
                <dl>- 최초 유효기간 종료 시 환불 신청금액의 90%에 대하여 환불이 진행됩니다.</dl>
                <dl>- 이벤트, 프로모션, 경품등으로 발송 된 상품이거나 제 3자에게 양도된 경우 환불이 제한될 수 있습니다.</dl>
                <dl>- 유효기간 시작일로부터 5년(1,825일)이 경과한 상품은 환불이 제한됩니다.</dl>
                <dl><dd></dd></dl>
                <dl>[환불일정 안내]</dl>
                <dl>- 매주 수요일까지 접수된 건에 한해 금요일 오후 6시경 일괄 입금됩니다.(일정 변경 시 별도 안내 예정)</dl>
                <dl>- 계좌 환불 시 입금자명은 “기프티엘환불”로 표기됩니다.</dl>
                <dl>- 계좌 오류 및 쿠폰확인불가 등 특이사항 발생 시 환불이 지연 될 수 있습니다.</dl>
                <dl>- 계좌번호를 잘못 입력하여 발생한 피해는 '스푼 주식회사'는 책임지지 않습니다.</dl>
              </dd>
            </dl>
          </div>
          <div class="grid-item notice">
            <dl>
              <dt>- 환불사항 관련 문의는 고객센터(1644-4276)로 문의해 주시기 바랍니다.</dt>
            </dl>
          </div>
          <div class="buttn-area">
            <button v-if="errors.any() || privacy == false || privacy2 == false " type="button" class="button-full gray">환불신청</button>
            <button v-if="!errors.any() && privacy == true && privacy2 == true " type="button" class="button-full blue" @click="submitItem" >환불신청</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import Header from '@/components/Header';
import Stepper from '@/components/Stepper';
import axios from 'axios';
import { encryptAes256 } from '@/utils/aesEncryptionUtil'
import { promised } from 'q';



const DEFAULT_FORM = {
csmr_name:'',
csmr_recv_hp_tel:'',
rfnd_fnlt_code:'',
rfnd_acnut_no:'',
rfnd_acnut_auth_yn:'',
refund_amt:''
}

export default{
  name: "Refund",
  components: {
    Header,
    Stepper
  },
  data(){
    return {
      key: this.$route.params.key,
      refund_amt : '',
      gcct_no: '',
      privacy : false,
      privacy2 : false,
      bankList: [],
      subForm: [],
      pin : '',
      order_no : '',
      gcct_state_code : '',
      sale_type_code : '',
      cnslt_info_cntn : '',
      rqst_product_no : '',
      rqst_no : '',
      rqst_se_code : ''
    }
  },
    activated() {
    localStorage.removeItem('subForm');
    this.checkBank()
  },
  created(){
     localStorage.removeItem('subForm');

     axios.post(`${process.env.ENDPOINT_03}/common/acnut`,{
       	fnlt_name: this.fnlt_name,
			  fnlt_code : this.fnlt_code,
	    	code_grp_no : this.code_grp_no
     })
    .then(response => {
      if(response.status==200){
        let data = response.data;
        if(data.return_cd === '0000'){
          this.bankList = data.response.list
        }
        else{
          console.log('cd error :', data.return_cd);
        }
      }
    })
    .catch(error => {
      console.log(error);
    });


     axios.get(`${process.env.ENDPOINT}/rfund/${this.key}`)
    .then(response => {
      if(response.status==200){
        let data = response.data;
        if(data.return_cd === '0000'){
          this.pin = data.response.list.pin
          this.refund_amt = data.response.list.refund_amt
          this.gcct_no = data.response.list.gcct_no
          this.order_no = data.response.list.order_no
          this.gcct_state_code = data.response.list.gcct_state_code
          this.sale_type_code = data.response.list.sale_type_code
          this.cnslt_info_cntn = data.response.list.cnslt_info_cntn
          this.rqst_product_no = data.response.list.rqst_product_no
          this.rqst_se_code = data.response.list.rqst_se_code
          this.rqst_no = data.response.list.rqst_no
        }
        else{
          console.log('cd error :', data.return_cd);
        }
      }
    })
    .catch(error => {
      console.log(error);
    })

    ;
  },
  methods: {
    // submit 전 데이터 입력
    // 데이터 보내기 전 포맷
    formatParams() {
      this.params.csmr_name = this.subForm.csmr_name
      this.params.csmr_recv_hp_tel = this.subForm.csmr_recv_hp_tel
      this.params.mpt_yn = this.subForm.mpt_yn
      // this.params.pin = this.subForm.pin..
      this.params.rfnd_acnut_auth_yn = this.subForm.rfnd_acnut_auth_yn
      this.params.rfnd_acnut_no = this.subForm.rfnd_acnut_no
      this.params.rfnd_fnlt_code = this.subForm.rfnd_fnlt_code
    },

    // 폼 초기화
    resetForm() {
      this.subForm = JSON.parse(JSON.stringify(DEFAULT_FORM))
      if (this.$refs['subForm'] !== undefined) this.$refs['subForm'].resetFields()
    },
     checkBank() {
        return new Promise((resolve) => {
            resolve( axios.post(`${process.env.ENDPOINT_04}/v1/common/nice/acnutPermit`,{
        strNm: encryptAes256(this.subForm.csmr_name),
        strResId: '000000', // 생년월일은 개인정보로 인해 하드코딩
        strAccountNo: encryptAes256(this.subForm.rfnd_acnut_no),
        strBankCode: encryptAes256(this.subForm.rfnd_fnlt_code),
        inq_rsn: '1',
        service: '1',
        strGbn: '1',
        gcct_no: encryptAes256(this.gcct_no),
        refund_req_amt: this.refund_amt,
        rqst_product_no: this.rqst_product_no,
        rqst_se_code: this.rqst_se_code,
        rqst_no: this.rqst_no
     })
    .then(response => {
      let data = response.data;
      if(response.status==200){
        if(data.return_cd == '0000'){
        return this.rfnd_acnut_auth_yn = 'Y'
        }else{
           alert(data.return_msg)
          console.log('error :', data.return_cd);
          return this.rfnd_acnut_auth_yn = 'N'
        }
      }
    })
    .catch(error => {
      console.log(error);
    }))
        })
    },
  // 환불 신청 등록
   async submitItem() {
      if(this.subForm.csmr_name == null || this.subForm.csmr_recv_hp_tel == null || this.subForm.rfnd_acnut_no == null || this.subForm.rfnd_fnlt_code == null  ){
        alert('입력을 해주세요')
      }else {
          if(confirm('환불신청을 하시겠습니까? (변경이 불가합니다)')){
              await this.checkBank()
            if(this.gcct_state_code > '000004' && this.gcct_state_code < '000009' || this.gcct_state_code === '000007' || this.gcct_state_code === '000008' || this.sale_type_code === '000002' ) {
              alert('구매가 취소되었거나 환불 불가한 쿠폰 입니다')
            }
            if(this.rfnd_acnut_auth_yn =='Y'){
               axios.put(`${process.env.ENDPOINT_04}/cs/refund/saveCsRefundRequestPermit`,{
                pin: this.pin,
                gcct_no: this.gcct_no,
                csmr_name : this.subForm.csmr_name,
                csmr_recv_hp_tel : this.subForm.csmr_recv_hp_tel,
                mpt_yn : 'N',
                rfnd_acnut_auth_yn : this.rfnd_acnut_auth_yn,
                rfnd_acnut_no : this.subForm.rfnd_acnut_no,
                rfnd_fnlt_code : this.subForm.rfnd_fnlt_code,
                rfnd_req_amt : this.refund_amt,
                order_no : this.order_no,
                cnslt_info_cntn : this.cnslt_info_cntn
              })
                .then(response => {
                  if(response.status==200){
                    const result = response.data.return_cd
                    const msg = response.data.return_msg
                    if(result == '0000'){
                    alert('환불신청이 완료되었습니다.')
                    this.$router.push({ name: 'RefundDetail',params: {
                      key : this.key }});
                    }
                    else{
                      alert(msg)
                      console.log('err_msg', msg)
                      console.log('err_code', result)
                    }
                  }
                })
                .catch(error => {
                  console.log(error);
                })
    };
          }}
      },
      numberWithCommas(x) {
      if (!!x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
    }
    }
  }
;
</script>

<style scoped lang='scss'>

@import '@/assets/styles/mixin.scss';
@import '@/assets/styles/contents.scss';

.num_font{
  font-size: x-small;
}
.refund_amt{
  font-size: large;
  }
.logo{
  text-align: center;
  margin-left: 100px;
  }
.notice {
  margin-top: 0px !important;
}
select {
  border-radius: 0;
}
.privacy {
  dl {
    dt {
      label {
        background: url(../assets/images/icon_privacy_toggle_bottom.png) no-repeat center right;
      }
      label.on {
        background: url(../assets/images/icon_privacy_toggle_top.png) no-repeat center right;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/views/Refund.vue